export class Icons {
    static icon_3d_rotation = '3d_rotation'
    static icon_ac_unit = 'ac_unit'
    static icon_access_alarm = 'access_alarm'
    static icon_access_alarms = 'access_alarms'
    static icon_access_time = 'access_time'
    static icon_accessibility = 'accessibility'
    static icon_accessible = 'accessible'
    static icon_account_balance = 'account_balance'
    static icon_account_balance_wallet = 'account_balance_wallet'
    static icon_account_box = 'account_box'
    static icon_account_circle = 'account_circle'
    static icon_adb = 'adb'
    static icon_add = 'add'
    static icon_add_a_photo = 'add_a_photo'
    static icon_add_alarm = 'add_alarm'
    static icon_add_alert = 'add_alert'
    static icon_add_box = 'add_box'
    static icon_add_circle = 'add_circle'
    static icon_add_circle_outline = 'add_circle_outline'
    static icon_add_location = 'add_location'
    static icon_add_shopping_cart = 'add_shopping_cart'
    static icon_add_to_photos = 'add_to_photos'
    static icon_add_to_queue = 'add_to_queue'
    static icon_adjust = 'adjust'
    static icon_airline_seat_flat = 'airline_seat_flat'
    static icon_airline_seat_flat_angled = 'airline_seat_flat_angled'
    static icon_airline_seat_individual_suite = 'airline_seat_individual_suite'
    static icon_airline_seat_legroom_extra = 'airline_seat_legroom_extra'
    static icon_airline_seat_legroom_normal = 'airline_seat_legroom_normal'
    static icon_airline_seat_legroom_reduced = 'airline_seat_legroom_reduced'
    static icon_airline_seat_recline_extra = 'airline_seat_recline_extra'
    static icon_airline_seat_recline_normal = 'airline_seat_recline_normal'
    static icon_airplanemode_active = 'airplanemode_active'
    static icon_airplanemode_inactive = 'airplanemode_inactive'
    static icon_airplay = 'airplay'
    static icon_airport_shuttle = 'airport_shuttle'
    static icon_alarm = 'alarm'
    static icon_alarm_add = 'alarm_add'
    static icon_alarm_off = 'alarm_off'
    static icon_alarm_on = 'alarm_on'
    static icon_album = 'album'
    static icon_all_inclusive = 'all_inclusive'
    static icon_all_out = 'all_out'
    static icon_android = 'android'
    static icon_announcement = 'announcement'
    static icon_apps = 'apps'
    static icon_archive = 'archive'
    static icon_arrow_back = 'arrow_back'
    static icon_arrow_downward = 'arrow_downward'
    static icon_arrow_drop_down = 'arrow_drop_down'
    static icon_arrow_drop_down_circle = 'arrow_drop_down_circle'
    static icon_arrow_drop_up = 'arrow_drop_up'
    static icon_arrow_forward = 'arrow_forward'
    static icon_arrow_upward = 'arrow_upward'
    static icon_art_track = 'art_track'
    static icon_aspect_ratio = 'aspect_ratio'
    static icon_assessment = 'assessment'
    static icon_assignment = 'assignment'
    static icon_assignment_ind = 'assignment_ind'
    static icon_assignment_late = 'assignment_late'
    static icon_assignment_return = 'assignment_return'
    static icon_assignment_returned = 'assignment_returned'
    static icon_assignment_turned_in = 'assignment_turned_in'
    static icon_assistant = 'assistant'
    static icon_assistant_photo = 'assistant_photo'
    static icon_attach_file = 'attach_file'
    static icon_attach_money = 'attach_money'
    static icon_attachment = 'attachment'
    static icon_audiotrack = 'audiotrack'
    static icon_autorenew = 'autorenew'
    static icon_av_timer = 'av_timer'
    static icon_backspace = 'backspace'
    static icon_backup = 'backup'
    static icon_battery_alert = 'battery_alert'
    static icon_battery_charging_full = 'battery_charging_full'
    static icon_battery_full = 'battery_full'
    static icon_battery_std = 'battery_std'
    static icon_battery_unknown = 'battery_unknown'
    static icon_beach_access = 'beach_access'
    static icon_beenhere = 'beenhere'
    static icon_block = 'block'
    static icon_bluetooth = 'bluetooth'
    static icon_bluetooth_audio = 'bluetooth_audio'
    static icon_bluetooth_connected = 'bluetooth_connected'
    static icon_bluetooth_disabled = 'bluetooth_disabled'
    static icon_bluetooth_searching = 'bluetooth_searching'
    static icon_blur_circular = 'blur_circular'
    static icon_blur_linear = 'blur_linear'
    static icon_blur_off = 'blur_off'
    static icon_blur_on = 'blur_on'
    static icon_book = 'book'
    static icon_bookmark = 'bookmark'
    static icon_bookmark_border = 'bookmark_border'
    static icon_border_all = 'border_all'
    static icon_border_bottom = 'border_bottom'
    static icon_border_clear = 'border_clear'
    static icon_border_color = 'border_color'
    static icon_border_horizontal = 'border_horizontal'
    static icon_border_inner = 'border_inner'
    static icon_border_left = 'border_left'
    static icon_border_outer = 'border_outer'
    static icon_border_right = 'border_right'
    static icon_border_style = 'border_style'
    static icon_border_top = 'border_top'
    static icon_border_vertical = 'border_vertical'
    static icon_branding_watermark = 'branding_watermark'
    static icon_brightness_1 = 'brightness_1'
    static icon_brightness_2 = 'brightness_2'
    static icon_brightness_3 = 'brightness_3'
    static icon_brightness_4 = 'brightness_4'
    static icon_brightness_5 = 'brightness_5'
    static icon_brightness_6 = 'brightness_6'
    static icon_brightness_7 = 'brightness_7'
    static icon_brightness_auto = 'brightness_auto'
    static icon_brightness_high = 'brightness_high'
    static icon_brightness_low = 'brightness_low'
    static icon_brightness_medium = 'brightness_medium'
    static icon_broken_image = 'broken_image'
    static icon_brush = 'brush'
    static icon_bubble_chart = 'bubble_chart'
    static icon_bug_report = 'bug_report'
    static icon_build = 'build'
    static icon_burst_mode = 'burst_mode'
    static icon_business = 'business'
    static icon_business_center = 'business_center'
    static icon_cached = 'cached'
    static icon_cake = 'cake'
    static icon_call = 'call'
    static icon_call_end = 'call_end'
    static icon_call_made = 'call_made'
    static icon_call_merge = 'call_merge'
    static icon_call_missed = 'call_missed'
    static icon_call_missed_outgoing = 'call_missed_outgoing'
    static icon_call_received = 'call_received'
    static icon_call_split = 'call_split'
    static icon_call_to_action = 'call_to_action'
    static icon_camera = 'camera'
    static icon_camera_alt = 'camera_alt'
    static icon_camera_enhance = 'camera_enhance'
    static icon_camera_front = 'camera_front'
    static icon_camera_rear = 'camera_rear'
    static icon_camera_roll = 'camera_roll'
    static icon_cancel = 'cancel'
    static icon_card_giftcard = 'card_giftcard'
    static icon_card_membership = 'card_membership'
    static icon_card_travel = 'card_travel'
    static icon_casino = 'casino'
    static icon_cast = 'cast'
    static icon_cast_connected = 'cast_connected'
    static icon_center_focus_strong = 'center_focus_strong'
    static icon_center_focus_weak = 'center_focus_weak'
    static icon_change_history = 'change_history'
    static icon_chat = 'chat'
    static icon_chat_bubble = 'chat_bubble'
    static icon_chat_bubble_outline = 'chat_bubble_outline'
    static icon_check = 'check'
    static icon_check_box = 'check_box'
    static icon_check_box_outline_blank = 'check_box_outline_blank'
    static icon_check_circle = 'check_circle'
    static icon_chevron_left = 'chevron_left'
    static icon_chevron_right = 'chevron_right'
    static icon_child_care = 'child_care'
    static icon_child_friendly = 'child_friendly'
    static icon_chrome_reader_mode = 'chrome_reader_mode'
    static icon_class = 'class'
    static icon_clear = 'clear'
    static icon_clear_all = 'clear_all'
    static icon_close = 'close'
    static icon_closed_caption = 'closed_caption'
    static icon_cloud = 'cloud'
    static icon_cloud_circle = 'cloud_circle'
    static icon_cloud_done = 'cloud_done'
    static icon_cloud_download = 'cloud_download'
    static icon_cloud_off = 'cloud_off'
    static icon_cloud_queue = 'cloud_queue'
    static icon_cloud_upload = 'cloud_upload'
    static icon_code = 'code'
    static icon_collections = 'collections'
    static icon_collections_bookmark = 'collections_bookmark'
    static icon_color_lens = 'color_lens'
    static icon_colorize = 'colorize'
    static icon_comment = 'comment'
    static icon_compare = 'compare'
    static icon_compare_arrows = 'compare_arrows'
    static icon_computer = 'computer'
    static icon_confirmation_number = 'confirmation_number'
    static icon_contact_mail = 'contact_mail'
    static icon_contact_phone = 'contact_phone'
    static icon_contacts = 'contacts'
    static icon_content_copy = 'content_copy'
    static icon_content_cut = 'content_cut'
    static icon_content_paste = 'content_paste'
    static icon_control_point = 'control_point'
    static icon_control_point_duplicate = 'control_point_duplicate'
    static icon_copyright = 'copyright'
    static icon_create = 'create'
    static icon_create_new_folder = 'create_new_folder'
    static icon_credit_card = 'credit_card'
    static icon_crop = 'crop'
    static icon_crop_16_9 = 'crop_16_9'
    static icon_crop_3_2 = 'crop_3_2'
    static icon_crop_5_4 = 'crop_5_4'
    static icon_crop_7_5 = 'crop_7_5'
    static icon_crop_din = 'crop_din'
    static icon_crop_free = 'crop_free'
    static icon_crop_landscape = 'crop_landscape'
    static icon_crop_original = 'crop_original'
    static icon_crop_portrait = 'crop_portrait'
    static icon_crop_rotate = 'crop_rotate'
    static icon_crop_square = 'crop_square'
    static icon_dashboard = 'dashboard'
    static icon_data_usage = 'data_usage'
    static icon_date_range = 'date_range'
    static icon_dehaze = 'dehaze'
    static icon_delete = 'delete'
    static icon_delete_forever = 'delete_forever'
    static icon_delete_sweep = 'delete_sweep'
    static icon_description = 'description'
    static icon_desktop_mac = 'desktop_mac'
    static icon_desktop_windows = 'desktop_windows'
    static icon_details = 'details'
    static icon_developer_board = 'developer_board'
    static icon_developer_mode = 'developer_mode'
    static icon_device_hub = 'device_hub'
    static icon_devices = 'devices'
    static icon_devices_other = 'devices_other'
    static icon_dialer_sip = 'dialer_sip'
    static icon_dialpad = 'dialpad'
    static icon_directions = 'directions'
    static icon_directions_bike = 'directions_bike'
    static icon_directions_boat = 'directions_boat'
    static icon_directions_bus = 'directions_bus'
    static icon_directions_car = 'directions_car'
    static icon_directions_railway = 'directions_railway'
    static icon_directions_run = 'directions_run'
    static icon_directions_subway = 'directions_subway'
    static icon_directions_transit = 'directions_transit'
    static icon_directions_walk = 'directions_walk'
    static icon_disc_full = 'disc_full'
    static icon_dns = 'dns'
    static icon_do_not_disturb = 'do_not_disturb'
    static icon_do_not_disturb_alt = 'do_not_disturb_alt'
    static icon_do_not_disturb_off = 'do_not_disturb_off'
    static icon_do_not_disturb_on = 'do_not_disturb_on'
    static icon_dock = 'dock'
    static icon_domain = 'domain'
    static icon_done = 'done'
    static icon_done_all = 'done_all'
    static icon_donut_large = 'donut_large'
    static icon_donut_small = 'donut_small'
    static icon_drafts = 'drafts'
    static icon_drag_handle = 'drag_handle'
    static icon_drive_eta = 'drive_eta'
    static icon_dvr = 'dvr'
    static icon_edit = 'edit'
    static icon_edit_location = 'edit_location'
    static icon_eject = 'eject'
    static icon_email = 'email'
    static icon_enhanced_encryption = 'enhanced_encryption'
    static icon_equalizer = 'equalizer'
    static icon_error = 'error'
    static icon_error_outline = 'error_outline'
    static icon_euro_symbol = 'euro_symbol'
    static icon_ev_station = 'ev_station'
    static icon_event = 'event'
    static icon_event_available = 'event_available'
    static icon_event_busy = 'event_busy'
    static icon_event_note = 'event_note'
    static icon_event_seat = 'event_seat'
    static icon_exit_to_app = 'exit_to_app'
    static icon_expand_less = 'expand_less'
    static icon_expand_more = 'expand_more'
    static icon_explicit = 'explicit'
    static icon_explore = 'explore'
    static icon_exposure = 'exposure'
    static icon_exposure_neg_1 = 'exposure_neg_1'
    static icon_exposure_neg_2 = 'exposure_neg_2'
    static icon_exposure_plus_1 = 'exposure_plus_1'
    static icon_exposure_plus_2 = 'exposure_plus_2'
    static icon_exposure_zero = 'exposure_zero'
    static icon_extension = 'extension'
    static icon_face = 'face'
    static icon_fast_forward = 'fast_forward'
    static icon_fast_rewind = 'fast_rewind'
    static icon_favorite = 'favorite'
    static icon_favorite_border = 'favorite_border'
    static icon_featured_play_list = 'featured_play_list'
    static icon_featured_video = 'featured_video'
    static icon_feedback = 'feedback'
    static icon_fiber_dvr = 'fiber_dvr'
    static icon_fiber_manual_record = 'fiber_manual_record'
    static icon_fiber_new = 'fiber_new'
    static icon_fiber_pin = 'fiber_pin'
    static icon_fiber_smart_record = 'fiber_smart_record'
    static icon_file_download = 'file_download'
    static icon_file_upload = 'file_upload'
    static icon_filter = 'filter'
    static icon_filter_1 = 'filter_1'
    static icon_filter_2 = 'filter_2'
    static icon_filter_3 = 'filter_3'
    static icon_filter_4 = 'filter_4'
    static icon_filter_5 = 'filter_5'
    static icon_filter_6 = 'filter_6'
    static icon_filter_7 = 'filter_7'
    static icon_filter_8 = 'filter_8'
    static icon_filter_9 = 'filter_9'
    static icon_filter_9_plus = 'filter_9_plus'
    static icon_filter_b_and_w = 'filter_b_and_w'
    static icon_filter_center_focus = 'filter_center_focus'
    static icon_filter_drama = 'filter_drama'
    static icon_filter_frames = 'filter_frames'
    static icon_filter_hdr = 'filter_hdr'
    static icon_filter_list = 'filter_list'
    static icon_filter_none = 'filter_none'
    static icon_filter_tilt_shift = 'filter_tilt_shift'
    static icon_filter_vintage = 'filter_vintage'
    static icon_find_in_page = 'find_in_page'
    static icon_find_replace = 'find_replace'
    static icon_fingerprint = 'fingerprint'
    static icon_first_page = 'first_page'
    static icon_fitness_center = 'fitness_center'
    static icon_flag = 'flag'
    static icon_flare = 'flare'
    static icon_flash_auto = 'flash_auto'
    static icon_flash_off = 'flash_off'
    static icon_flash_on = 'flash_on'
    static icon_flight = 'flight'
    static icon_flight_land = 'flight_land'
    static icon_flight_takeoff = 'flight_takeoff'
    static icon_flip = 'flip'
    static icon_flip_to_back = 'flip_to_back'
    static icon_flip_to_front = 'flip_to_front'
    static icon_folder = 'folder'
    static icon_folder_open = 'folder_open'
    static icon_folder_shared = 'folder_shared'
    static icon_folder_special = 'folder_special'
    static icon_font_download = 'font_download'
    static icon_format_align_center = 'format_align_center'
    static icon_format_align_justify = 'format_align_justify'
    static icon_format_align_left = 'format_align_left'
    static icon_format_align_right = 'format_align_right'
    static icon_format_bold = 'format_bold'
    static icon_format_clear = 'format_clear'
    static icon_format_color_fill = 'format_color_fill'
    static icon_format_color_reset = 'format_color_reset'
    static icon_format_color_text = 'format_color_text'
    static icon_format_indent_decrease = 'format_indent_decrease'
    static icon_format_indent_increase = 'format_indent_increase'
    static icon_format_italic = 'format_italic'
    static icon_format_line_spacing = 'format_line_spacing'
    static icon_format_list_bulleted = 'format_list_bulleted'
    static icon_format_list_numbered = 'format_list_numbered'
    static icon_format_paint = 'format_paint'
    static icon_format_quote = 'format_quote'
    static icon_format_shapes = 'format_shapes'
    static icon_format_size = 'format_size'
    static icon_format_strikethrough = 'format_strikethrough'
    static icon_format_textdirection_l_to_r = 'format_textdirection_l_to_r'
    static icon_format_textdirection_r_to_l = 'format_textdirection_r_to_l'
    static icon_format_underlined = 'format_underlined'
    static icon_forum = 'forum'
    static icon_forward = 'forward'
    static icon_forward_10 = 'forward_10'
    static icon_forward_30 = 'forward_30'
    static icon_forward_5 = 'forward_5'
    static icon_free_breakfast = 'free_breakfast'
    static icon_fullscreen = 'fullscreen'
    static icon_fullscreen_exit = 'fullscreen_exit'
    static icon_functions = 'functions'
    static icon_g_translate = 'g_translate'
    static icon_gamepad = 'gamepad'
    static icon_games = 'games'
    static icon_gavel = 'gavel'
    static icon_gesture = 'gesture'
    static icon_get_app = 'get_app'
    static icon_gif = 'gif'
    static icon_golf_course = 'golf_course'
    static icon_gps_fixed = 'gps_fixed'
    static icon_gps_not_fixed = 'gps_not_fixed'
    static icon_gps_off = 'gps_off'
    static icon_grade = 'grade'
    static icon_gradient = 'gradient'
    static icon_grain = 'grain'
    static icon_graphic_eq = 'graphic_eq'
    static icon_grid_off = 'grid_off'
    static icon_grid_on = 'grid_on'
    static icon_group = 'group'
    static icon_group_add = 'group_add'
    static icon_group_work = 'group_work'
    static icon_hd = 'hd'
    static icon_hdr_off = 'hdr_off'
    static icon_hdr_on = 'hdr_on'
    static icon_hdr_strong = 'hdr_strong'
    static icon_hdr_weak = 'hdr_weak'
    static icon_headset = 'headset'
    static icon_headset_mic = 'headset_mic'
    static icon_healing = 'healing'
    static icon_hearing = 'hearing'
    static icon_help = 'help'
    static icon_help_outline = 'help_outline'
    static icon_high_quality = 'high_quality'
    static icon_highlight = 'highlight'
    static icon_highlight_off = 'highlight_off'
    static icon_history = 'history'
    static icon_home = 'home'
    static icon_hot_tub = 'hot_tub'
    static icon_hotel = 'hotel'
    static icon_hourglass_empty = 'hourglass_empty'
    static icon_hourglass_full = 'hourglass_full'
    static icon_http = 'http'
    static icon_https = 'https'
    static icon_image = 'image'
    static icon_image_aspect_ratio = 'image_aspect_ratio'
    static icon_import_contacts = 'import_contacts'
    static icon_import_export = 'import_export'
    static icon_important_devices = 'important_devices'
    static icon_inbox = 'inbox'
    static icon_indeterminate_check_box = 'indeterminate_check_box'
    static icon_info = 'info'
    static icon_info_outline = 'info_outline'
    static icon_input = 'input'
    static icon_insert_chart = 'insert_chart'
    static icon_insert_comment = 'insert_comment'
    static icon_insert_drive_file = 'insert_drive_file'
    static icon_insert_emoticon = 'insert_emoticon'
    static icon_insert_invitation = 'insert_invitation'
    static icon_insert_link = 'insert_link'
    static icon_insert_photo = 'insert_photo'
    static icon_invert_colors = 'invert_colors'
    static icon_invert_colors_off = 'invert_colors_off'
    static icon_iso = 'iso'
    static icon_keyboard = 'keyboard'
    static icon_keyboard_arrow_down = 'keyboard_arrow_down'
    static icon_keyboard_arrow_left = 'keyboard_arrow_left'
    static icon_keyboard_arrow_right = 'keyboard_arrow_right'
    static icon_keyboard_arrow_up = 'keyboard_arrow_up'
    static icon_keyboard_backspace = 'keyboard_backspace'
    static icon_keyboard_capslock = 'keyboard_capslock'
    static icon_keyboard_hide = 'keyboard_hide'
    static icon_keyboard_return = 'keyboard_return'
    static icon_keyboard_tab = 'keyboard_tab'
    static icon_keyboard_voice = 'keyboard_voice'
    static icon_kitchen = 'kitchen'
    static icon_label = 'label'
    static icon_label_outline = 'label_outline'
    static icon_landscape = 'landscape'
    static icon_language = 'language'
    static icon_laptop = 'laptop'
    static icon_laptop_chromebook = 'laptop_chromebook'
    static icon_laptop_mac = 'laptop_mac'
    static icon_laptop_windows = 'laptop_windows'
    static icon_last_page = 'last_page'
    static icon_launch = 'launch'
    static icon_layers = 'layers'
    static icon_layers_clear = 'layers_clear'
    static icon_leak_add = 'leak_add'
    static icon_leak_remove = 'leak_remove'
    static icon_lens = 'lens'
    static icon_library_add = 'library_add'
    static icon_library_books = 'library_books'
    static icon_library_music = 'library_music'
    static icon_lightbulb_outline = 'lightbulb_outline'
    static icon_line_style = 'line_style'
    static icon_line_weight = 'line_weight'
    static icon_linear_scale = 'linear_scale'
    static icon_link = 'link'
    static icon_linked_camera = 'linked_camera'
    static icon_list = 'list'
    static icon_live_help = 'live_help'
    static icon_live_tv = 'live_tv'
    static icon_local_activity = 'local_activity'
    static icon_local_airport = 'local_airport'
    static icon_local_atm = 'local_atm'
    static icon_local_bar = 'local_bar'
    static icon_local_cafe = 'local_cafe'
    static icon_local_car_wash = 'local_car_wash'
    static icon_local_convenience_store = 'local_convenience_store'
    static icon_local_dining = 'local_dining'
    static icon_local_drink = 'local_drink'
    static icon_local_florist = 'local_florist'
    static icon_local_gas_station = 'local_gas_station'
    static icon_local_grocery_store = 'local_grocery_store'
    static icon_local_hospital = 'local_hospital'
    static icon_local_hotel = 'local_hotel'
    static icon_local_laundry_service = 'local_laundry_service'
    static icon_local_library = 'local_library'
    static icon_local_mall = 'local_mall'
    static icon_local_movies = 'local_movies'
    static icon_local_offer = 'local_offer'
    static icon_local_parking = 'local_parking'
    static icon_local_pharmacy = 'local_pharmacy'
    static icon_local_phone = 'local_phone'
    static icon_local_pizza = 'local_pizza'
    static icon_local_play = 'local_play'
    static icon_local_post_office = 'local_post_office'
    static icon_local_printshop = 'local_printshop'
    static icon_local_see = 'local_see'
    static icon_local_shipping = 'local_shipping'
    static icon_local_taxi = 'local_taxi'
    static icon_location_city = 'location_city'
    static icon_location_disabled = 'location_disabled'
    static icon_location_off = 'location_off'
    static icon_location_on = 'location_on'
    static icon_location_searching = 'location_searching'
    static icon_lock = 'lock'
    static icon_lock_open = 'lock_open'
    static icon_lock_outline = 'lock_outline'
    static icon_looks = 'looks'
    static icon_looks_3 = 'looks_3'
    static icon_looks_4 = 'looks_4'
    static icon_looks_5 = 'looks_5'
    static icon_looks_6 = 'looks_6'
    static icon_looks_one = 'looks_one'
    static icon_looks_two = 'looks_two'
    static icon_loop = 'loop'
    static icon_loupe = 'loupe'
    static icon_low_priority = 'low_priority'
    static icon_loyalty = 'loyalty'
    static icon_mail = 'mail'
    static icon_mail_outline = 'mail_outline'
    static icon_map = 'map'
    static icon_markunread = 'markunread'
    static icon_markunread_mailbox = 'markunread_mailbox'
    static icon_memory = 'memory'
    static icon_menu = 'menu'
    static icon_merge_type = 'merge_type'
    static icon_message = 'message'
    static icon_mic = 'mic'
    static icon_mic_none = 'mic_none'
    static icon_mic_off = 'mic_off'
    static icon_mms = 'mms'
    static icon_mode_comment = 'mode_comment'
    static icon_mode_edit = 'mode_edit'
    static icon_monetization_on = 'monetization_on'
    static icon_money_off = 'money_off'
    static icon_monochrome_photos = 'monochrome_photos'
    static icon_mood = 'mood'
    static icon_mood_bad = 'mood_bad'
    static icon_more = 'more'
    static icon_more_horiz = 'more_horiz'
    static icon_more_vert = 'more_vert'
    static icon_motorcycle = 'motorcycle'
    static icon_mouse = 'mouse'
    static icon_move_to_inbox = 'move_to_inbox'
    static icon_movie = 'movie'
    static icon_movie_creation = 'movie_creation'
    static icon_movie_filter = 'movie_filter'
    static icon_multiline_chart = 'multiline_chart'
    static icon_music_note = 'music_note'
    static icon_music_video = 'music_video'
    static icon_my_location = 'my_location'
    static icon_nature = 'nature'
    static icon_nature_people = 'nature_people'
    static icon_navigate_before = 'navigate_before'
    static icon_navigate_next = 'navigate_next'
    static icon_navigation = 'navigation'
    static icon_near_me = 'near_me'
    static icon_network_cell = 'network_cell'
    static icon_network_check = 'network_check'
    static icon_network_locked = 'network_locked'
    static icon_network_wifi = 'network_wifi'
    static icon_new_releases = 'new_releases'
    static icon_next_week = 'next_week'
    static icon_nfc = 'nfc'
    static icon_no_encryption = 'no_encryption'
    static icon_no_sim = 'no_sim'
    static icon_not_interested = 'not_interested'
    static icon_note = 'note'
    static icon_note_add = 'note_add'
    static icon_notifications = 'notifications'
    static icon_notifications_active = 'notifications_active'
    static icon_notifications_none = 'notifications_none'
    static icon_notifications_off = 'notifications_off'
    static icon_notifications_paused = 'notifications_paused'
    static icon_offline_pin = 'offline_pin'
    static icon_ondemand_video = 'ondemand_video'
    static icon_opacity = 'opacity'
    static icon_open_in_browser = 'open_in_browser'
    static icon_open_in_new = 'open_in_new'
    static icon_open_with = 'open_with'
    static icon_pages = 'pages'
    static icon_pageview = 'pageview'
    static icon_palette = 'palette'
    static icon_pan_tool = 'pan_tool'
    static icon_panorama = 'panorama'
    static icon_panorama_fish_eye = 'panorama_fish_eye'
    static icon_panorama_horizontal = 'panorama_horizontal'
    static icon_panorama_vertical = 'panorama_vertical'
    static icon_panorama_wide_angle = 'panorama_wide_angle'
    static icon_party_mode = 'party_mode'
    static icon_pause = 'pause'
    static icon_pause_circle_filled = 'pause_circle_filled'
    static icon_pause_circle_outline = 'pause_circle_outline'
    static icon_payment = 'payment'
    static icon_people = 'people'
    static icon_people_outline = 'people_outline'
    static icon_perm_camera_mic = 'perm_camera_mic'
    static icon_perm_contact_calendar = 'perm_contact_calendar'
    static icon_perm_data_setting = 'perm_data_setting'
    static icon_perm_device_information = 'perm_device_information'
    static icon_perm_identity = 'perm_identity'
    static icon_perm_media = 'perm_media'
    static icon_perm_phone_msg = 'perm_phone_msg'
    static icon_perm_scan_wifi = 'perm_scan_wifi'
    static icon_person = 'person'
    static icon_person_add = 'person_add'
    static icon_person_outline = 'person_outline'
    static icon_person_pin = 'person_pin'
    static icon_person_pin_circle = 'person_pin_circle'
    static icon_personal_video = 'personal_video'
    static icon_pets = 'pets'
    static icon_phone = 'phone'
    static icon_phone_android = 'phone_android'
    static icon_phone_bluetooth_speaker = 'phone_bluetooth_speaker'
    static icon_phone_forwarded = 'phone_forwarded'
    static icon_phone_in_talk = 'phone_in_talk'
    static icon_phone_iphone = 'phone_iphone'
    static icon_phone_locked = 'phone_locked'
    static icon_phone_missed = 'phone_missed'
    static icon_phone_paused = 'phone_paused'
    static icon_phonelink = 'phonelink'
    static icon_phonelink_erase = 'phonelink_erase'
    static icon_phonelink_lock = 'phonelink_lock'
    static icon_phonelink_off = 'phonelink_off'
    static icon_phonelink_ring = 'phonelink_ring'
    static icon_phonelink_setup = 'phonelink_setup'
    static icon_photo = 'photo'
    static icon_photo_album = 'photo_album'
    static icon_photo_camera = 'photo_camera'
    static icon_photo_filter = 'photo_filter'
    static icon_photo_library = 'photo_library'
    static icon_photo_size_select_actual = 'photo_size_select_actual'
    static icon_photo_size_select_large = 'photo_size_select_large'
    static icon_photo_size_select_small = 'photo_size_select_small'
    static icon_picture_as_pdf = 'picture_as_pdf'
    static icon_picture_in_picture = 'picture_in_picture'
    static icon_picture_in_picture_alt = 'picture_in_picture_alt'
    static icon_pie_chart = 'pie_chart'
    static icon_pie_chart_outlined = 'pie_chart_outlined'
    static icon_pin_drop = 'pin_drop'
    static icon_place = 'place'
    static icon_play_arrow = 'play_arrow'
    static icon_play_circle_filled = 'play_circle_filled'
    static icon_play_circle_outline = 'play_circle_outline'
    static icon_play_for_work = 'play_for_work'
    static icon_playlist_add = 'playlist_add'
    static icon_playlist_add_check = 'playlist_add_check'
    static icon_playlist_play = 'playlist_play'
    static icon_plus_one = 'plus_one'
    static icon_poll = 'poll'
    static icon_polymer = 'polymer'
    static icon_pool = 'pool'
    static icon_portable_wifi_off = 'portable_wifi_off'
    static icon_portrait = 'portrait'
    static icon_power = 'power'
    static icon_power_input = 'power_input'
    static icon_power_settings_new = 'power_settings_new'
    static icon_pregnant_woman = 'pregnant_woman'
    static icon_present_to_all = 'present_to_all'
    static icon_print = 'print'
    static icon_priority_high = 'priority_high'
    static icon_public = 'public'
    static icon_publish = 'publish'
    static icon_query_builder = 'query_builder'
    static icon_question_answer = 'question_answer'
    static icon_queue = 'queue'
    static icon_queue_music = 'queue_music'
    static icon_queue_play_next = 'queue_play_next'
    static icon_radio = 'radio'
    static icon_radio_button_checked = 'radio_button_checked'
    static icon_radio_button_unchecked = 'radio_button_unchecked'
    static icon_rate_review = 'rate_review'
    static icon_receipt = 'receipt'
    static icon_recent_actors = 'recent_actors'
    static icon_record_voice_over = 'record_voice_over'
    static icon_redeem = 'redeem'
    static icon_redo = 'redo'
    static icon_refresh = 'refresh'
    static icon_remove = 'remove'
    static icon_remove_circle = 'remove_circle'
    static icon_remove_circle_outline = 'remove_circle_outline'
    static icon_remove_from_queue = 'remove_from_queue'
    static icon_remove_red_eye = 'remove_red_eye'
    static icon_remove_shopping_cart = 'remove_shopping_cart'
    static icon_reorder = 'reorder'
    static icon_repeat = 'repeat'
    static icon_repeat_one = 'repeat_one'
    static icon_replay = 'replay'
    static icon_replay_10 = 'replay_10'
    static icon_replay_30 = 'replay_30'
    static icon_replay_5 = 'replay_5'
    static icon_reply = 'reply'
    static icon_reply_all = 'reply_all'
    static icon_report = 'report'
    static icon_report_problem = 'report_problem'
    static icon_restaurant = 'restaurant'
    static icon_restaurant_menu = 'restaurant_menu'
    static icon_restore = 'restore'
    static icon_restore_page = 'restore_page'
    static icon_ring_volume = 'ring_volume'
    static icon_room = 'room'
    static icon_room_service = 'room_service'
    static icon_rotate_90_degrees_ccw = 'rotate_90_degrees_ccw'
    static icon_rotate_left = 'rotate_left'
    static icon_rotate_right = 'rotate_right'
    static icon_rounded_corner = 'rounded_corner'
    static icon_router = 'router'
    static icon_rowing = 'rowing'
    static icon_rss_feed = 'rss_feed'
    static icon_rv_hookup = 'rv_hookup'
    static icon_satellite = 'satellite'
    static icon_save = 'save'
    static icon_scanner = 'scanner'
    static icon_schedule = 'schedule'
    static icon_school = 'school'
    static icon_screen_lock_landscape = 'screen_lock_landscape'
    static icon_screen_lock_portrait = 'screen_lock_portrait'
    static icon_screen_lock_rotation = 'screen_lock_rotation'
    static icon_screen_rotation = 'screen_rotation'
    static icon_screen_share = 'screen_share'
    static icon_sd_card = 'sd_card'
    static icon_sd_storage = 'sd_storage'
    static icon_search = 'search'
    static icon_security = 'security'
    static icon_select_all = 'select_all'
    static icon_send = 'send'
    static icon_sentiment_dissatisfied = 'sentiment_dissatisfied'
    static icon_sentiment_neutral = 'sentiment_neutral'
    static icon_sentiment_satisfied = 'sentiment_satisfied'
    static icon_sentiment_very_dissatisfied = 'sentiment_very_dissatisfied'
    static icon_sentiment_very_satisfied = 'sentiment_very_satisfied'
    static icon_settings = 'settings'
    static icon_settings_applications = 'settings_applications'
    static icon_settings_backup_restore = 'settings_backup_restore'
    static icon_settings_bluetooth = 'settings_bluetooth'
    static icon_settings_brightness = 'settings_brightness'
    static icon_settings_cell = 'settings_cell'
    static icon_settings_ethernet = 'settings_ethernet'
    static icon_settings_input_antenna = 'settings_input_antenna'
    static icon_settings_input_component = 'settings_input_component'
    static icon_settings_input_composite = 'settings_input_composite'
    static icon_settings_input_hdmi = 'settings_input_hdmi'
    static icon_settings_input_svideo = 'settings_input_svideo'
    static icon_settings_overscan = 'settings_overscan'
    static icon_settings_phone = 'settings_phone'
    static icon_settings_power = 'settings_power'
    static icon_settings_remote = 'settings_remote'
    static icon_settings_system_daydream = 'settings_system_daydream'
    static icon_settings_voice = 'settings_voice'
    static icon_share = 'share'
    static icon_shop = 'shop'
    static icon_shop_two = 'shop_two'
    static icon_shopping_basket = 'shopping_basket'
    static icon_shopping_cart = 'shopping_cart'
    static icon_short_text = 'short_text'
    static icon_show_chart = 'show_chart'
    static icon_shuffle = 'shuffle'
    static icon_signal_cellular_4_bar = 'signal_cellular_4_bar'
    static icon_signal_cellular_connected_no_internet_4_bar = 'signal_cellular_connected_no_internet_4_bar'
    static icon_signal_cellular_no_sim = 'signal_cellular_no_sim'
    static icon_signal_cellular_null = 'signal_cellular_null'
    static icon_signal_cellular_off = 'signal_cellular_off'
    static icon_signal_wifi_4_bar = 'signal_wifi_4_bar'
    static icon_signal_wifi_4_bar_lock = 'signal_wifi_4_bar_lock'
    static icon_signal_wifi_off = 'signal_wifi_off'
    static icon_sim_card = 'sim_card'
    static icon_sim_card_alert = 'sim_card_alert'
    static icon_skip_next = 'skip_next'
    static icon_skip_previous = 'skip_previous'
    static icon_slideshow = 'slideshow'
    static icon_slow_motion_video = 'slow_motion_video'
    static icon_smartphone = 'smartphone'
    static icon_smoke_free = 'smoke_free'
    static icon_smoking_rooms = 'smoking_rooms'
    static icon_sms = 'sms'
    static icon_sms_failed = 'sms_failed'
    static icon_snooze = 'snooze'
    static icon_sort = 'sort'
    static icon_sort_by_alpha = 'sort_by_alpha'
    static icon_spa = 'spa'
    static icon_space_bar = 'space_bar'
    static icon_speaker = 'speaker'
    static icon_speaker_group = 'speaker_group'
    static icon_speaker_notes = 'speaker_notes'
    static icon_speaker_notes_off = 'speaker_notes_off'
    static icon_speaker_phone = 'speaker_phone'
    static icon_spellcheck = 'spellcheck'
    static icon_star = 'star'
    static icon_star_border = 'star_border'
    static icon_star_half = 'star_half'
    static icon_stars = 'stars'
    static icon_stay_current_landscape = 'stay_current_landscape'
    static icon_stay_current_portrait = 'stay_current_portrait'
    static icon_stay_primary_landscape = 'stay_primary_landscape'
    static icon_stay_primary_portrait = 'stay_primary_portrait'
    static icon_stop = 'stop'
    static icon_stop_screen_share = 'stop_screen_share'
    static icon_storage = 'storage'
    static icon_store = 'store'
    static icon_store_mall_directory = 'store_mall_directory'
    static icon_straighten = 'straighten'
    static icon_streetview = 'streetview'
    static icon_strikethrough_s = 'strikethrough_s'
    static icon_style = 'style'
    static icon_subdirectory_arrow_left = 'subdirectory_arrow_left'
    static icon_subdirectory_arrow_right = 'subdirectory_arrow_right'
    static icon_subject = 'subject'
    static icon_subscriptions = 'subscriptions'
    static icon_subtitles = 'subtitles'
    static icon_subway = 'subway'
    static icon_supervisor_account = 'supervisor_account'
    static icon_surround_sound = 'surround_sound'
    static icon_swap_calls = 'swap_calls'
    static icon_swap_horiz = 'swap_horiz'
    static icon_swap_vert = 'swap_vert'
    static icon_swap_vertical_circle = 'swap_vertical_circle'
    static icon_switch_camera = 'switch_camera'
    static icon_switch_video = 'switch_video'
    static icon_sync = 'sync'
    static icon_sync_disabled = 'sync_disabled'
    static icon_sync_problem = 'sync_problem'
    static icon_system_update = 'system_update'
    static icon_system_update_alt = 'system_update_alt'
    static icon_tab = 'tab'
    static icon_tab_unselected = 'tab_unselected'
    static icon_tablet = 'tablet'
    static icon_tablet_android = 'tablet_android'
    static icon_tablet_mac = 'tablet_mac'
    static icon_tag_faces = 'tag_faces'
    static icon_tap_and_play = 'tap_and_play'
    static icon_terrain = 'terrain'
    static icon_text_fields = 'text_fields'
    static icon_text_format = 'text_format'
    static icon_textsms = 'textsms'
    static icon_texture = 'texture'
    static icon_theaters = 'theaters'
    static icon_thumb_down = 'thumb_down'
    static icon_thumb_up = 'thumb_up'
    static icon_thumbs_up_down = 'thumbs_up_down'
    static icon_time_to_leave = 'time_to_leave'
    static icon_timelapse = 'timelapse'
    static icon_timeline = 'timeline'
    static icon_timer = 'timer'
    static icon_timer_10 = 'timer_10'
    static icon_timer_3 = 'timer_3'
    static icon_timer_off = 'timer_off'
    static icon_title = 'title'
    static icon_toc = 'toc'
    static icon_today = 'today'
    static icon_toll = 'toll'
    static icon_tonality = 'tonality'
    static icon_touch_app = 'touch_app'
    static icon_toys = 'toys'
    static icon_track_changes = 'track_changes'
    static icon_traffic = 'traffic'
    static icon_train = 'train'
    static icon_tram = 'tram'
    static icon_transfer_within_a_station = 'transfer_within_a_station'
    static icon_transform = 'transform'
    static icon_translate = 'translate'
    static icon_trending_down = 'trending_down'
    static icon_trending_flat = 'trending_flat'
    static icon_trending_up = 'trending_up'
    static icon_tune = 'tune'
    static icon_turned_in = 'turned_in'
    static icon_turned_in_not = 'turned_in_not'
    static icon_tv = 'tv'
    static icon_unarchive = 'unarchive'
    static icon_undo = 'undo'
    static icon_unfold_less = 'unfold_less'
    static icon_unfold_more = 'unfold_more'
    static icon_update = 'update'
    static icon_usb = 'usb'
    static icon_verified_user = 'verified_user'
    static icon_vertical_align_bottom = 'vertical_align_bottom'
    static icon_vertical_align_center = 'vertical_align_center'
    static icon_vertical_align_top = 'vertical_align_top'
    static icon_vibration = 'vibration'
    static icon_video_call = 'video_call'
    static icon_video_label = 'video_label'
    static icon_video_library = 'video_library'
    static icon_videocam = 'videocam'
    static icon_videocam_off = 'videocam_off'
    static icon_videogame_asset = 'videogame_asset'
    static icon_view_agenda = 'view_agenda'
    static icon_view_array = 'view_array'
    static icon_view_carousel = 'view_carousel'
    static icon_view_column = 'view_column'
    static icon_view_comfy = 'view_comfy'
    static icon_view_compact = 'view_compact'
    static icon_view_day = 'view_day'
    static icon_view_headline = 'view_headline'
    static icon_view_list = 'view_list'
    static icon_view_module = 'view_module'
    static icon_view_quilt = 'view_quilt'
    static icon_view_stream = 'view_stream'
    static icon_view_week = 'view_week'
    static icon_vignette = 'vignette'
    static icon_visibility = 'visibility'
    static icon_visibility_off = 'visibility_off'
    static icon_voice_chat = 'voice_chat'
    static icon_voicemail = 'voicemail'
    static icon_volume_down = 'volume_down'
    static icon_volume_mute = 'volume_mute'
    static icon_volume_off = 'volume_off'
    static icon_volume_up = 'volume_up'
    static icon_vpn_key = 'vpn_key'
    static icon_vpn_lock = 'vpn_lock'
    static icon_wallpaper = 'wallpaper'
    static icon_warning = 'warning'
    static icon_watch = 'watch'
    static icon_watch_later = 'watch_later'
    static icon_wb_auto = 'wb_auto'
    static icon_wb_cloudy = 'wb_cloudy'
    static icon_wb_incandescent = 'wb_incandescent'
    static icon_wb_iridescent = 'wb_iridescent'
    static icon_wb_sunny = 'wb_sunny'
    static icon_wc = 'wc'
    static icon_web = 'web'
    static icon_web_asset = 'web_asset'
    static icon_weekend = 'weekend'
    static icon_whatshot = 'whatshot'
    static icon_widgets = 'widgets'
    static icon_wifi = 'wifi'
    static icon_wifi_lock = 'wifi_lock'
    static icon_wifi_tethering = 'wifi_tethering'
    static icon_work = 'work'
    static icon_wrap_text = 'wrap_text'
    static icon_youtube_searched_for = 'youtube_searched_for'
    static icon_zoom_in = 'zoom_in'
    static icon_zoom_out = 'zoom_out'
    static icon_zoom_out_map = 'zoom_out_map'
}